import { Inject, Injectable, Optional } from '@angular/core';

import { Bloc, BLOC_DEBUG } from '@connect-services/client/blocs/bloc';
import { FieldInterventionsService } from '@connect-services/client/sdk/api';

@Injectable({
    providedIn: 'root',
})
export class FieldInterventionLayerBloc extends Bloc<
    FieldInterventionsService['fieldInterventionControllerGetLayersWithAttributes']
> {
    public constructor(service: FieldInterventionsService, @Inject(BLOC_DEBUG) @Optional() debug?: boolean) {
        super(service.fieldInterventionControllerGetLayersWithAttributes.bind(service), {
            debug: debug ?? false,
        });
    }
}
